/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */

import {
    Component,
    ElementRef,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    inject,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(`:host { display: flex; flex-wrap: wrap; }`);

@Component({
    selector: 'bazis-row',
    template: '<slot></slot>',
    // styleUrls: ['row.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RowElement implements OnInit {
    public el = inject(ElementRef);

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
